// extracted by mini-css-extract-plugin
export default {"contenedor":"pie_contenedor__22Bsc","textoUno":"pie_textoUno__dWK2S","textoDos":"pie_textoDos__0Z71n"};